import React from "react";
import "../styles/Footer.css";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaLinkedinIn,
  FaWhatsapp,
  FaArrowUp,
} from "react-icons/fa";

const Footer = () => {

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">

      <div className="footer-top-line"></div>

      <div className="footer-container">

        {/* Company */}

        <div className="footer-column">

          <h2>ITWORLD</h2>

          <span className="footer-badge">
            Serving Fuel Stations Since 1994
          </span>

          <p>
            ITWORLD delivers complete technology solutions for
            petrol pumps across Pakistan. Our expertise includes
            Accounts ERP, Live Nozzle Automation, Fuel Receipt
            Printing and External Display Systems.
          </p>

          <div className="footer-social">

            <a href="/">
              <FaFacebookF />
            </a>

            <a href="/">
              <FaLinkedinIn />
            </a>

            <a
              href="https://wa.me/923039692162"
              target="_blank"
              rel="noreferrer"
            >
              <FaWhatsapp />
            </a>

          </div>

        </div>

        {/* Solutions */}

        <div className="footer-column">

          <h3>Our Solutions</h3>

          <ul>

            <li>Accounts ERP</li>

            <li>Nozzle Automation</li>

            <li>Fuel Receipt Printing</li>

            <li>External Display</li>

            <li>Inventory Management</li>

            <li>Tank Monitoring</li>

          </ul>

        </div>

        {/* Quick Links */}

        <div className="footer-column">

          <h3>Quick Links</h3>

          <ul>

            <li>
              <a href="#home">Home</a>
            </li>

            <li>
              <a href="#about">About</a>
            </li>

            <li>
              <a href="#services">Services</a>
            </li>

            <li>
              <a href="#products">Products</a>
            </li>

            <li>
              <a href="#contact">Contact</a>
            </li>

          </ul>

        </div>

        {/* Contact */}

        <div className="footer-column">

          <h3>Contact</h3>

          <div className="footer-contact">

            <div>

              <FaPhoneAlt />

              <span>0303-9692162</span>

            </div>

            <div>

              <FaPhoneAlt />

              <span>0300-4170612</span>

            </div>

            <div>

              <FaEnvelope />

              <span>itworldmanagement@gmail.com</span>

            </div>

            <div>

              <FaMapMarkerAlt />

              <span>
                Second Floor
                <br />
                18 Sunny Park
                <br />
                Lahore
              </span>

            </div>

          </div>

        </div>

      </div>

      <div className="footer-bottom">

        <p>

          © {new Date().getFullYear()} ITWORLD. All Rights Reserved.

        </p>

        <button
          className="footer-top-btn"
          onClick={scrollTop}
        >

          <FaArrowUp />

        </button>

      </div>

    </footer>
  );
};

export default Footer;